import { Image } from 'expo-image';
import * as React from 'react';
import { View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { Style as StyleIcon } from '@/ui/icons/style';

interface ImagePlaceholderProps {
  // Final asset source. When provided, the image is rendered.
  source?: any;
  // Short label describing the asset the designer should drop in here.
  label?: string;
  style?: any;
  rounded?: number;
  contentFit?: 'cover' | 'contain';
  children?: React.ReactNode;
}

/**
 * Renders the final asset when `source` is provided, otherwise a muted,
 * labelled surface so any still-pending asset slot stays obvious.
 */
export const ImagePlaceholder = ({
  source,
  label,
  style,
  rounded = 16,
  contentFit = 'cover',
  children,
}: ImagePlaceholderProps) => {
  const { theme } = useStyles();

  if (source) {
    return (
      <Image
        source={source}
        contentFit={contentFit}
        style={[{ borderRadius: rounded }, style]}
      />
    );
  }

  return (
    <View
      style={[
        {
          backgroundColor: theme.colors.background_3,
          borderRadius: rounded,
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          gap: 8,
          padding: 12,
        },
        style,
      ]}
    >
      {children ?? (
        <>
          <Icon
            type="naked"
            icon={<StyleIcon />}
            stroke={theme.colors.text.secondary50}
            width={28}
            height={28}
          />
          {label ? (
            <Text
              type="caption2"
              style={{
                color: theme.colors.text.secondary50,
                textAlign: 'center',
              }}
            >
              {label}
            </Text>
          ) : null}
        </>
      )}
    </View>
  );
};
